import React from "react";
import {StyledCheckbox, StyledFormControlLabel} from "./styles";
import PropTypes from "prop-types";

const Checkbox = props => {
    const {label, checked, onCheckedChanged} = props;

    return (<StyledFormControlLabel
        control={<StyledCheckbox value={checked} onChange={e => onCheckedChanged(e.target.checked)} />}
        label={label}
        value={checked}
    />);
}

Checkbox.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool,
    onCheckedChanged: PropTypes.func,
}

export default Checkbox;
